import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IdleServiceService } from './core/services/IdleService.service';
import { PssToastContainerComponent } from './shared/toast/pss-toast-container.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PssToastContainerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'cityparking-admin';
  appVersion = '1.0.0';

  constructor(private idleService: IdleServiceService , private http: HttpClient) {}

  ngOnInit(): void {
    this.checkAppVersion();
  }

  checkAppVersion(): void {
    this.http
      .get<{ version: string }>('./json/version.json', {
        headers: { 'Cache-Control': 'no-cache' },
      })
      .subscribe((response) => {
        const currentVersion = localStorage.getItem('app_version');

        if (currentVersion && currentVersion !== response.version) {
          this.appVersion = response.version;
          console.log('🔄 เวอร์ชันใหม่พบ → โหลดหน้าใหม่');
          localStorage.setItem('app_version', response.version);
          location.reload();
        } else {
          localStorage.setItem('app_version', response.version);
        }
      });
  }
}
